<template>
  <v-container fluid>
    <v-btn class="nav-btn" icon color="#f3f3f3" small @click="$router.back()">
      <v-icon>close</v-icon>
    </v-btn>
    <template v-if="survey">
      <h3>{{ survey.name }}</h3>
      <p class="survey-desc" v-if="survey.desc">{{ survey.desc }}</p>
      <v-divider />
      <div class="survey-item" v-for="(i, idx) in items" :key="i.id">
        <p>
          {{ idx + 1 }}. <v-chip v-if="i.multiSel" small>多选</v-chip>{{ i.title }}
        </p>
        <ul>
          <li v-for="opt in i.opts" :key="opt">{{ opt }}</li>
        </ul>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  name: "survey-view",
  data() {
    return { survey: null, items: null };
  },
  methods: {
    init() {
      let self = this,
        id = self.$route.params._sid;
      self.$axios.get(`/home/admin/c/survey/get/${id}`).then((r) => {
        self.survey = r.data.message;
        let items = r.data.items;
        for (let item of items) {
          let opts = [];
          for (let i = 1; i < 7; i++) {
            if (!item["opt" + i]) {
              break;
            }
            opts.push(item["opt" + i]);
          }
          item.opts = opts;
        }
        self.items = items;
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
h3 {
  font-weight: normal;
}

.nav-btn {
  float: right;
}

.survey-desc {
  margin: 8px 0;
  color: #888;
}

.v-divider {
  margin: 16px 0;
}

.survey-item p {
  margin: 0;
  padding: 0;
}

.survey-item ul {
  margin-top: 8px;
  font-size: 12px;
  line-height: 24px;
}
</style>